module.exports = __webpack_public_path__ + "static/media/backmb.4f204e8c.jpg";